import dayjs from "dayjs";

export const convertToLocalFromDatabaseDateTime = (date?: string) => {
  if (!date) return undefined;
  return dayjs(`${date}Z`).format("YYYY-MM-DDTHH:mm:ss").toString();
};

export const calculateAge = (dateOfBirth: string) => {
  if (!dateOfBirth) return undefined;
  return dayjs().diff(dayjs(dateOfBirth), "years");
};

export const getFileDateLabel = (createdDate: string, modifiedDate: string) => {
  if (!createdDate || !modifiedDate) return undefined;

  const created = dayjs(createdDate).format("MMM DD, YYYY");
  const modified = dayjs(modifiedDate).format("MMM DD, YYYY");

  return dayjs(createdDate).isSame(dayjs(modifiedDate), "day")
    ? created
    : `${created} (Last Modified: ${modified})`;
};
